import React, { Fragment, useState, useEffect } from "react";
import ListSurveysPatients from './ListSurveysPatients';
import ListSurveyPatientsActions from './ListSurveyPatientsActions';
import Spinner from 'react-bootstrap/Spinner';

const SurveysAdministrativeShow = ({ }) => {

    const [dataSurvey, setDataSurvey] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getDataSurveys();
    }, []);

    const getDataSurveys = async () => {
        setLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'encuesta-paciente/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(data => {
            setDataSurvey(data);
            setLoading(false);
        }).catch((error) => {
            setDataSurvey([]);
            setLoading(false);
            console.error('Error:', error);
        });
    }

    return (
        <Fragment>
            {
                loading ? <div className="text-center">
                    <Spinner animation="border" variant="success" />
                </div> : <ListSurveysPatients reactTableData={dataSurvey} ReactTableActions={ListSurveyPatientsActions} />
            }

        </Fragment>
    );
}
export default SurveysAdministrativeShow;